import { getPermissions, getTpPermissions } from '../localstorage/localstorage.service'

export function menuItemsAllowed(menu_items) {
  const allowed = []
  menu_items.forEach(item => {
    const allowedID = getPermissions().find(i => i === item.id)
    if (allowedID) {
      allowed.push(item.content)
    }
  })
  return allowed
}

export function isRouteAllowed(user_action_id) {
  if (!user_action_id) return true
  const permissions = getPermissions() || []
  return permissions.some(p => p === user_action_id)
}

export function verifyTpPermission(permission_id, tpId) {
  if (!permission_id) return true
  return getTpPermissions(tpId).some(p => p === permission_id)
}

export class TpPermissions {
  static DASHBOARD = 1
  static CADASTROS = 2
  static ENTREGAS = 3
  static PICKING = 4
  static ORDEM_COLETA = 5
  static PATRIMONIO = 6
  static INSUMO = 7
  static ESTOQUE = 8
  static GESTAO_PATIO = 9
  static CHECKLIST_OPERACIONAL = 10
}

export class ChecklistOperacionalPermissions {
  static CADASTRO_CHECKLIST = 151
  static PREENCHIMENTO_CHECKLIST = 153
}
